import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="p-24 ">
      <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 ">
        <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>

        {/* <p className="mb-4 text-sm text-gray-600 text-center">
        Effective Date: [Insert Date]
      </p> */}

        <section className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
            <p>
              Genmindz ("Company," "we," "our," or "us") respects
              your privacy and is committed to protecting it through this
              Privacy Policy. This policy outlines how we collect, use,
              disclose, and safeguard your information when you use our Visitor
              Management System ("VMS").
            </p>
          </div>

          <div style={{
            marginBottom: '15px'
          }}>
            <h2 className="text-xl font-semibold mb-2">
              2. Information We Collect
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>Personal Information:</strong> Name, email address,
                phone number, company name, photograph (if applicable),
                government-issued ID details (if required).
              </li>
              <li>
                <strong>Visit Details:</strong> Check-in/check-out times,
                purpose of visit, host details, and location.
              </li>
              <li>
                <strong>Device Information:</strong> IP address, browser type,
                and operating system.
              </li>
              {/* <li>
                <strong>Security Data:</strong> CCTV footage or biometric data
                (if applicable).
              </li> */}
            </ul>
          </div>

          <div style={{
            marginBottom: '15px'
          }}>
            <h2 className="text-xl font-semibold mb-2">
              3. How We Use Your Information
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Visitor registration, verification, and access control.</li>
              <li>Enhancing security and managing emergency situations.</li>
              <li>Sending notifications and visitor updates.</li>
              <li>
                Compliance with legal obligations and law enforcement requests.
              </li>
            </ul>
          </div>

          <div style={{
            marginBottom: '15px'
          }}>
            <h2 className="text-xl font-semibold mb-2">
              4. Data Sharing & Storage
            </h2>
            <p className="mb-2">
              We do not sell your personal data. However, we may share
              information with:
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Authorized personnel such as employees or security staff.</li>
              <li>
                Service providers managing cloud storage, authentication, or
                analytics.
              </li>
              <li>
                Legal authorities if required by law or for security
                investigations.
              </li>
            </ul>
            <p>
              Your data is stored securely and retained as per applicable laws
              and company policies.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">5. Security Measures</h2>
            <p>
              We implement technical and organizational measures to protect your
              data against unauthorized access, loss, or misuse.
            </p>
          </div>

          <div style={{
            marginBottom: '15px'
          }}>
            <h2 className="text-xl font-semibold mb-2">6. Your Rights</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Access, update, or delete your data.</li>
              <li>Object to data processing or withdraw consent.</li>
              <li>Request a copy of your stored information.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">7. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us at:{" "}
              <a
                href="mailto:contact@genmindz.net"
                className="text-blue-600 underline"
              >
                contact@genmindz.net
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
